import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyATpga7qzoHxztGjpFTRthQxz3CCCfzobE',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'guffpuff-llc.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'guffpuff-llc',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'guffpuff-llc.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '529714170586',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:529714170586:android:8afd3ad775b114efc8f3e3',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export default app;
